export const getLoginRedirect = (location: { pathname: string; search: string }) => {
  const searchParams = new URLSearchParams(location.search)
  const hasSource = searchParams.has('source')
  const sourceValue = hasSource ? searchParams.get('source') : null

  if (hasSource) {
    searchParams.delete('source')
  }

  const searchWithoutSource = searchParams.toString()
  const redirectUri = encodeURI(location.pathname + (searchWithoutSource ? `?${searchWithoutSource}` : ''))

  return {
    hasSource,
    sourceValue,
    redirectUri,
  }
}
